import { Action } from 'redux';
import { Subject } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { ErrorType } from '../../../store/reducers/common';
import { nextStep } from '../../application/reducers/next-step';
import {
  uploadDocuments,
  uploadDocumentsFail,
  uploadDocumentsSuccess,
  uploadStatusUpdate,
} from '../reducers/document-requirements.reducer';

export const uploadDocumentsEpic: RootEpic = (action$, state$, { api: { qualification } }) => {
  return action$.pipe(
    filter(uploadDocuments.match),
    mergeMap(({ payload: { documents, nextAction } }) => {
      const subject = new Subject<Action>();

      qualification
        .uploadDocuments(documents, nextAction, (event) => {
          subject.next(uploadStatusUpdate(event));
        })
        .then(() => {
          subject.next(uploadDocumentsSuccess());
          subject.next(
            nextStep({
              action: nextAction,
              gotoNextPage: true,
            }),
          );
          subject.complete();
        })
        .catch((error: ErrorType) => {
          subject.next(uploadDocumentsFail(error));
          subject.complete();
        });

      return subject;
    }),
  );
};
